/**
 * @voltxampere/ui — 74HC08 quad AND CMOS variant (Sprint 42-1)
 *
 * Reference: TI SN74HC08. CMOS sibling of the Sprint 41-4 7408.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc08 = {
    id: "74hc08",
    nameTr: "74HC08 (4'lü AND CMOS, DIP-14)",
    nameEn: "74HC08 (Quad AND CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC08",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "AND",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 8e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc08.js.map